<div class="flex flex-col h-full">

  <!-- Header -->
  <div class="flex flex-row items-center justify-between px-6 pt-5 pb-3 border-b border-grey-200">
    <span class="text-lg font-semibold text-grey-900">{{ title }}</span>
    <button mat-icon-button [mat-dialog-close]="null" aria-label="Close">
      <mat-icon class="text-grey-500" style="font-size: 20px; height: 20px; width: 20px;">close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content class="flex flex-col gap-4 flex-1 overflow-hidden px-6 pt-4 pb-4" [formGroup]="form">

    <!-- DMS Service Group section -->
    <section class="flex flex-col gap-2 flex-1 min-h-0">
      <span class="text-xs font-semibold text-grey-700 uppercase tracking-wide">
        DMS Service Group <span class="text-red-500">*</span>
      </span>

      <!-- Search -->
      <div class="flex items-center border border-grey-300 rounded px-3 h-9 bg-white">
        <mat-icon class="text-grey-400 shrink-0 mr-1.5"
          style="font-size: 18px; height: 18px; width: 18px;">search</mat-icon>
        <input [formControl]="searchControl" placeholder="Search by op code or name" autocomplete="off"
          class="outline-none text-sm flex-1 bg-transparent text-grey-700 placeholder-grey-400" />
      </div>

      <!-- Picker list -->
      <div role="listbox" aria-label="Select a service group"
        class="flex-1 border border-grey-200 rounded overflow-y-auto min-h-0">
        <div *ngFor="let sg of filteredGroups; trackBy: trackById"
          role="option"
          [attr.aria-selected]="isSelected(sg)"
          tabindex="0"
          class="op-code-row w-full flex items-center px-3 py-2 border-b border-grey-100 cursor-pointer outline-none"
          [class.selected]="isSelected(sg)"
          (click)="selectGroup(sg)"
          (keydown.enter)="selectGroup(sg); $event.preventDefault()"
          (keydown.space)="selectGroup(sg); $event.preventDefault()">
          <mat-icon aria-hidden="true" class="mr-3 shrink-0"
            [ngClass]="isSelected(sg) ? 'text-blue-600' : 'text-grey-400'"
            style="font-size: 20px; height: 20px; width: 20px;">
            {{ isSelected(sg) ? 'radio_button_checked' : 'radio_button_unchecked' }}
          </mat-icon>
          <span class="op-code-chip shrink-0 mr-3 op-code-id">{{ sg.workOrderLocationOpCode ?? '—' }}</span>
          <span class="flex-1 min-w-0 text-sm op-code-name truncate">{{ sg.name }}</span>
        </div>

        <div *ngIf="filteredGroups.length === 0" class="flex items-center justify-center h-16">
          <span class="text-sm text-grey-400">No results found</span>
        </div>
      </div>
    </section>

    <!-- Service Intervals section -->
    <section class="flex flex-col gap-2 border-t border-grey-200 pt-4">
      <span class="text-xs font-semibold text-grey-700 uppercase tracking-wide">
        Service Intervals <span class="text-red-500">*</span>
      </span>
      <p class="text-xs text-grey-500">At least one interval must be provided. Both can be used together.</p>

      <div class="flex gap-3">
        <div class="flex flex-col flex-1">
          <label class="text-xs text-grey-600 mb-1">Mileage</label>
          <div class="flex items-center border border-grey-300 rounded px-2 h-9 bg-white">
            <input type="number" min="1" step="1" formControlName="intervalMileage" placeholder="e.g. 5000"
              class="outline-none text-sm flex-1 bg-transparent text-grey-700 placeholder-grey-400" />
            <span class="text-xs text-grey-500 ml-2 shrink-0 px-2 py-0.5 bg-grey-100 rounded">{{ distanceUnitLabel }}</span>
          </div>
          <span class="text-xs text-grey-500 mt-1">Leave blank if not applicable</span>
        </div>
        <div class="flex flex-col flex-1">
          <label class="text-xs text-grey-600 mb-1">Time</label>
          <div class="flex items-center border border-grey-300 rounded px-2 h-9 bg-white">
            <input type="number" min="1" step="1" formControlName="intervalMonths" placeholder="e.g. 6"
              class="outline-none text-sm flex-1 bg-transparent text-grey-700 placeholder-grey-400" />
            <span class="text-xs text-grey-500 ml-2 shrink-0 px-2 py-0.5 bg-grey-100 rounded">mo</span>
          </div>
          <span class="text-xs text-grey-500 mt-1">Leave blank if not applicable</span>
        </div>
      </div>

      <p *ngIf="form.errors?.noInterval && (form.touched || form.dirty)" class="text-xs text-red-600">
        At least one interval is required.
      </p>
    </section>

  </div>

  <!-- Footer -->
  <div class="flex justify-end items-center px-6 py-4 gap-2 border-t border-grey-200">
    <button mat-button [mat-dialog-close]="null" class="rounded">Cancel</button>
    <button mat-raised-button color="primary" class="rounded" [disabled]="!canSave" (click)="save()">Save</button>
  </div>

</div>
